import { ArrowDown } from "lucide-react";

export default function SpinBadge({ text = "SUGEE LAKE DISTRICT • THANE WEST • NEW LAUNCH • " }) {
  return (
    <div data-testid="spin-badge" className="relative h-32 w-32">
      <svg viewBox="0 0 100 100" className="h-full w-full animate-spin-slow">
        <defs>
          <path id="spinCircle" d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" />
        </defs>
        <text className="fill-white/85" style={{ fontSize: 8, letterSpacing: 2.6, textTransform: "uppercase" }}>
          <textPath href="#spinCircle">{text}</textPath>
        </text>
      </svg>
      <span className="absolute inset-0 flex items-center justify-center">
        <ArrowDown size={18} className="text-white/80" strokeWidth={1.5} />
      </span>
    </div>
  );
}
